import Vue from 'vue'
import Router from 'vue-router'

import ContentPage from '@/components/ContentPage'

import companyRoutes from '@/company/routes'
import adminRoutes from '@/admin/routes'
import publisherRoutes from '@/publisher/routes'
import demandRoutes from '@/demand/routes'
import exchangeRoutes from '@/exchange/routes'
import reportsRoutes from '@/reports/routes'
import supportRoutes from '@/support/routes'


import { vm } from '@/main'

import auth from '@/auth'

import Login from '@/components/pages/Login'
import AccountDetails from '@/accounts/pages/Account'
import PageNotFound from '@/components/pages/PageNotFound'
import Contracts from '@/components/pages/Contracts'

Vue.use(Router)

/* Add additional routes definitions here */
let children = []
children.push(...companyRoutes)
children.push(...adminRoutes)
children.push(...publisherRoutes)
children.push(...exchangeRoutes)
children.push(...demandRoutes)
children.push(...reportsRoutes)
children.push(...supportRoutes)
//add 404 page to children so authenticated users see content-page UI on their 404 page
children.push(
  {
    path: '/account/:uid',
    name: 'AccountDetails',
    component: AccountDetails,
    props: true,
    meta: {
      breadcrumbs: [ { name: 'My Account', to: { name: 'AccountDetails' } } ]
    }
  },
  {
    path: '/account/:cid/:uid',
    name: 'AccountCreate',
    component: AccountDetails,
    props: true,
    meta: {
      breadcrumbs: [ { name: 'Create Account', to: { name: 'AccountDetails' } } ]
    }
  },
  {
    path: '/contracts',
    name: 'Contracts',
    component: Contracts,
    meta: {
      breadcrumbs: [ { name: 'Market Contracts' } ]
    }
  },
  {
    path: '*',
    component: PageNotFound
  }
)

let routes = [
  {
    path: '/login',
    component: Login,
    name: 'Login',
    meta: { auth: false },
    beforeEnter (to, from, next) {
      console.log(to)
      if(to.query.next === '/' || to.query.next === '') {
        next(to.path)
      }
      next()
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    beforeEnter (to, from, next) {
      let type
      if (auth.hasPerm('ADMIN')) {
        type = 'admin'
      } else {
        if(auth.publisher() !== null) {
          type = 'publisher'
        } else if(auth.demand() !== null) {
          type = 'demand'
        } else if(auth.exchange() !== null) {
          type = 'exchange'
        } else {
          next('/profile') /* brand new */
          return
        }
      }
      next('/' + type + '/dashboard')
    }
  },
  {
    path: '/logout',
    beforeEnter (to, from, next) {
      auth.logout()
      next('/login')
    }
  },
  {
    path: '/',
    meta: { auth: true },
    component: ContentPage,
    children: children
  }
]

const router = new Router({
  mode: 'history',
	routes: routes
})

/*
 * if user has permission to go to the page routed to with route, returns true
 * else, returns false
 */
function userHasPermissions (route) {
  console.log("auth check")
  let permissions = route.meta.permissions
  if (!permissions) {
    //page does not have access restrictions
    return true
  } else {
    for (let permission of permissions) {
      if (auth.perms().indexOf(permission) !== -1) {
        return true
      }
    }
  }
  return false
}

router.beforeEach((to, from, next) => {
  console.log("off to " + to.path)
  // console.log('fromquery',from.query)
  // console.log('toquery', to.query)

  //update page title
  if ('meta' in to && 'title' in to.meta) {
    document.title = to.meta.title + ' | SmartRTB'
  } else {
    document.title = 'Marketplace | ' + BRAND
  }

  if (to.meta.auth !== false && !auth.isAuthenticated()) {
    console.debug('Not logged in, redirecting')
    next({ name: 'Login', query: { next: to.path }})
  } else if (!userHasPermissions(to)) {
    if (vm) {
      vm.$notify.error("You don't have permission to access that page")
      if (from.name === 'Login') {
        next({ name: 'Dashboard' })
      }
    } else {
      next({ name: 'Login' })
    }
    next(false)
  } else if (to.path === '/' && auth.isAuthenticated()) {
    console.debug('Already logged in')
    next('/dashboard')
  } else if ('switchToPublisherView' in to.query) {
    // We want to switch to the exchange view (admin only)
    // We need to use a seperate query from exchangeView bc
    // otherwise exchangeview would just get switched off again
    // console.log('THE SWITHC')
    let newQuery = to.query
    // console.log('newquery', newQuery)
    delete newQuery.exchangeView
    delete newQuery.switchToPublisherView
    // console.log('newquery', newQuery)
    next({ path: to.path, query: newQuery })
  } else if ('exchangeView' in from.query
    && !('exchangeView' in to.query)
    && from.path !== to.path) {
    // force vue to hold on to the exchangeView query (admin only)
    // so we can navigate around with and it won't be lost
    let newQuery = to.query
    newQuery.exchangeView = true
    next({ path: to.path, query: newQuery })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js